import { Box, Container, Typography } from '@mui/material'
import { ReactNode } from 'react'

import { QC } from '../logo/logo'

import styles from './global-error.module.scss'

export function GlobalError({
  heading,
  children,
}: React.PropsWithChildren<{ heading?: ReactNode }>) {
  return (
    <Box className={styles.root}>
      <Container className={styles.container}>
        <div className={styles.header}>
          {heading ?? (
            <>
              <QC width={183} />
              <div>
                We&apos;re experiencing
                <Typography color="inherit" variant="h2" component="h1">
                  an issue...
                </Typography>
              </div>
            </>
          )}
        </div>
        <div className={styles.textBody}>{children}</div>
      </Container>
    </Box>
  )
}
